import { render, staticRenderFns } from "./FormTeacherDocument.vue?vue&type=template&id=09974a6a&scoped=true&"
import script from "./FormTeacherDocument.vue?vue&type=script&lang=js&"
export * from "./FormTeacherDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09974a6a",
  null
  
)

export default component.exports